import './instrumentation';
import React from 'react';
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';

// Use createRoot to render your React app
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

